import { ConciergeContextSettingsParser } from "@redotech/redo-model/concierge-settings/context-settings-db-parser";
import { z } from "zod";

export const setConciergeContextSettings = {
  input: ConciergeContextSettingsParser,
  output: z.object({ success: z.boolean() }),
};
